import React from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import { Spinner } from "office-ui-fabric-react";

import "./Loading.css";

class Loading extends React.Component {
    componentDidMount() { }

    componentWillUnmount() { }

    render() {
        // const { language } = this.context;
        const { show, message } = this.props;
        return (
            show && (
                <div className="loader-container">
                    <div className="spinner-container">
                        <Spinner label={message} />
                    </div>
                </div>
            )
        );
    }
}

Loading.propTypes = {
    show: Proptypes.bool,
    message: Proptypes.string
};

export default Loading;